import { defineComponent, openBlock, createBlock, unref, withCtx, createTextVNode } from 'vue';
import { Button } from '@ssml-editor/vue';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "undo-menu",
  props: {
    editor: {}
  },
  setup(__props) {
    function menuClickHandler() {
      if (__props.editor) {
        __props.editor.undo();
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Button), {
        "icon-class": "iconfont-ssml-editor icon-ssml-editor-chexiao",
        onClick: menuClickHandler
      }, {
        default: withCtx(() => [
          createTextVNode("撤销")
        ]),
        _: 1
      });
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=undo-menu.vue.js.map
